import { dxtToLocalServerTime, dxtToUTC } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import UnLinkIcon from "@mui/icons-material/LinkOff";
import RestoreIcon from "@mui/icons-material/Restore";
import IconButton from "@mui/material/IconButton";
import { ICellRendererParams } from "ag-grid-enterprise";
import numeral from "numeral";

type Props = ICellRendererParams & {
	dateTimeFormat?: string;
	convertToLocalTime?: boolean;
	numericFormat?: string;
	clicked: Function;
	isEnabled: string;
	linkProperty?: string;
	link?: string;
	popUpOptions?: Record<string, string>[];
};
export const ToggleStatusButtonCellRenderer = (props: Props) => {
	if (props.data[props.isEnabled] === true)
		return (
			<>
				<DeleteButtonCellRenderer {...props} />
			</>
		);
	else
		return (
			<>
				<ActiveButtonCellRenderer {...props} />
			</>
		);
};
export const EditButtonCellRenderer = (props: Props) => {
	function btnClickedHandler() {
		(async () => {
			await props.clicked(props.data);
		})();
	}
	return (
		<>
			<IconButton
				aria-label="edit"
				size="small"
				title="Edit"
				color="primary"
				style={{ cursor: "pointer" }}
				onClick={btnClickedHandler}
			>
				<EditIcon fontSize="inherit" style={{ cursor: "pointer" }} />
			</IconButton>
		</>
	);
};
export const DeleteButtonCellRenderer = (props: Props) => {
	function btnClickedHandler() {
		(async () => {
			if (props.clicked === undefined) return;
			await props.clicked(props.data);
		})();
	}
	return (
		<>
			<IconButton
				aria-label="delete"
				size="small"
				title="Delete"
				style={{ cursor: "pointer" }}
				onClick={btnClickedHandler}
			>
				<DeleteIcon
					fontSize="inherit"
					color="secondary"
					style={{ cursor: "pointer" }}
				/>
			</IconButton>
		</>
	);
};
export const ActiveButtonCellRenderer = (props: Props) => {
	function btnClickedHandler() {
		if (props.clicked === undefined) return;
		props.clicked(props.data);
	}
	return (
		<>
			<IconButton
				aria-label="active"
				title="Active"
				size="small"
				style={{ cursor: "pointer" }}
				onClick={btnClickedHandler}
			>
				<RestoreIcon
					fontSize="inherit"
					color="primary"
					style={{ cursor: "pointer" }}
				/>
			</IconButton>
		</>
	);
};
export const UnLinkButtonCellRenderer = (props: Props) => {
	function btnClickedHandler() {
		(async () => {
			await props.clicked(props.data);
		})();
	}
	return (
		<>
			<IconButton
				aria-label="unlink"
				size="small"
				title="Unlink"
				color="primary"
				style={{ cursor: "pointer" }}
				onClick={btnClickedHandler}
			>
				<UnLinkIcon fontSize="inherit" style={{ cursor: "pointer" }} />
			</IconButton>
		</>
	);
};
export const DateTimeCellRenderer = (props: Props) => {
	if (props.value === null || props.value === undefined) return <></>;
	let value;
	if (props.convertToLocalTime) {
		value = dxtToLocalServerTime(props.value, props.dateTimeFormat || "HH:mm");
	} else {
		value = dxtToUTC(props.value, props.dateTimeFormat || "HH:mm");
	}
	return (
		<>
			<span>{value}</span>
		</>
	);
};
export const NumericCellRenderer = (props: Props) => {
	if (props.value === null || props.value === undefined) return <></>;

	const m = numeral(props.value);
	const format = props.numericFormat === "" ? "0.00" : props.numericFormat;
	const formatCell = Number.isNaN(m.value) ? "NaN" : m.format(format);

	return <span>{formatCell}</span>;
};
export const LinkCellRenderer = (props: Props) => {
	if (props.value === null || props.value === undefined) return <></>;
	if (props.link) {
		return (
			<>
				<a href={props.link} target="_self" rel="noopener noreferrer">
					{props.value}
				</a>
			</>
		);
	}
	const link = props.data[props.linkProperty ?? ""] ?? "";
	return (
		<>
			<a href={link} target="_self" rel="noopener noreferrer">
				{props.value}
			</a>
		</>
	);
};
